import React from 'react';
// import './Footer.scss'; // Create an empty file if no additional styles are needed

function Footer() {
  return (
    <footer className="full-screen">
      <div className="section-content">
        <p>Michael Gary Dean</p>
        <nav className="footer-nav">
          <a href="mailto:contact@michaelgarydean.com">contact@michaelgarydean.com</a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
